import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ItineraryService } from '../../../core/services/itinerary.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CountryService } from '../../../core/services/country.service';
import { SettingService } from '../../../core/services/setting.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { MapboxService } from '../../../core/services/mapbox.service';
import { JsReportService } from '../../../core/services/js-report.service';
import { determineIsTimeExpired } from '../../../core/ult-functions/time';
import { ViewContentComponent } from '../view-content/view-content.component';
import {
  AddEditCustomerInformationComponent
} from '../add-edit-customer-information/add-edit-customer-information.component';
import { geoJSONManager } from '../../../core/ult-functions/geo';
import * as moment from 'moment/moment';
import { SETTINGS } from '../../../core/config/common.settings';
import { getAccommodationPerDate } from '../../../core/ult-functions/accommodation';
import { LocalizationService } from '../../../core/services/localization.service';
import {NzMessageService} from "ng-zorro-antd/message";
import {Location} from "@angular/common";
import {CrispService} from "../../../core/services/crisp.service";
import {MetaService} from "../../../core/services/meta.service";
import { formatDynamicPricingCell } from '../../../core/ult-functions/common';

@Component({
  selector: 'app-preview-itinarary-two',
  templateUrl: './preview-itinarary-two.component.html',
  styleUrls: ['./preview-itinarary-two.component.scss']
})
export class PreviewItinararyTwoComponent implements OnInit, OnDestroy {

  limit = {
    lScreen: 220,
    mdScreen: 100
  };
  data: any;
  rId: any;
  rWatched: any;
  loading = false;
  organizationSetting: any;
  placeholderPath: any = "../assets/img/placeholder-image.png";
  protected countries: any = [];
  countriesJson: any = [];
  protected citiesByCountry: any = [];
  image: any;
  isClientUrl = false;
  private intervalId: any;
  timeLeft: any;
  isNotExpiredRealTime = true;
  protected readonly SETTINGS = SETTINGS;
  protected readonly getAccommodationPerDate = getAccommodationPerDate;
  @ViewChild("swiperRef", { static: false, read: ElementRef }) swiperRef?: ElementRef;
  @ViewChild("swiperTourDayRef", { static: false, read: ElementRef }) swiperTourDayRef?: ElementRef;
  localizationContent: any;
  pageType: any;

  selectedDayIndex: number | null = null;

  headingColor: string = '#9B9B9B'; // Default color
  tourOperatorTitle = '';

  constructor(
    private itineraryService: ItineraryService, private route: ActivatedRoute, private router: Router,
    private countryService: CountryService, private settingService: SettingService, private nzModalService: NzModalService,
    private mapBoxService: MapboxService,
    private reportService: JsReportService,
    private localizationService: LocalizationService, private crisp: CrispService,
    private messageService: NzMessageService, private metaService: MetaService) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.crisp.hideChat();
    this.rId = this.route.snapshot.paramMap.get("id");
    this.rWatched = this.route.snapshot.paramMap.get("watched");
    this.route.queryParamMap.subscribe(params => {
      this.pageType = params.get("rretMgxg");
    });
    // check whether current url is client or not
    const currentUrl = this.router.url;
    this.isClientUrl = currentUrl.includes("/client");
    Promise.all([this.loadItineraryByID()]).then(() => {
      this.loading = false;
      if (currentUrl.includes("/btob")) {
        if (this.data?.tour?.type !== "B2B") {
          this.router.navigate(["/unauthorized"]);
        }
      }
      if (this.data?.tour?.type === "B2C" && this.pageType === "nono"){
        this.updateViewCount().then();
      }
      if (this.data?.tour?.type === "B2B" && this.data.isLinkExpirationEnabled) {
        this.intervalId = setInterval(() => {
          this.timeLeft = this.timeUntil24HoursExpires(this.data.b2b.time);
          this.isNotExpiredRealTime = determineIsTimeExpired(this.data.b2b.time);
        }, 1000); // Run every 1 second
      } else {
        this.isNotExpiredRealTime = false;
      }
    })
      .catch((error) => {
        console.error("Error loading itinerary:", error);
      });
  }
  ngOnDestroy(): void {
    // Clear the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.crisp.showChat();
  }

  goNext(): void  {
    const index = this.swiperRef?.nativeElement.swiper.activeIndex + 1;
    const swiper = this.swiperRef?.nativeElement.swiper;
    if (index < this.swiperRef?.nativeElement.swiper.slides.length) {
      swiper.slideNext();
    }
  }

  getOPNameByLanguage(opHeading: any[], lang: string): string {
    const item = opHeading.find(x => x.language === lang);
    return item ? item.name : "Tour Executive";
  }

  goPrev(): void {
    const index = this.swiperRef?.nativeElement.swiper.activeIndex + 1;
    const swiper = this.swiperRef?.nativeElement.swiper;
    if (index > 0) {
      swiper.slidePrev();
    }
  }

  goTourNext(): void  {
    const index = this.swiperTourDayRef?.nativeElement.swiper.activeIndex + 1;
    const swiper = this.swiperTourDayRef?.nativeElement.swiper;
    if (index < this.swiperTourDayRef?.nativeElement.swiper.slides.length) {
      swiper.slideNext();
    }
  }

  goTourPrev(): void {
    const index = this.swiperTourDayRef?.nativeElement.swiper.activeIndex + 1;
    const swiper = this.swiperTourDayRef?.nativeElement.swiper;
    if (index > 0) {
      swiper.slidePrev();
    }
  }

  async sendEmail(): Promise<any> {
    const data = {
      id: this.data._id,
      customer: this.data.tour.customer.first_name + " " + this.data.tour.customer.last_name,
      creator: this.data.creator[0].name,
      referenceNo: this.data.tour.referenceNo,
    };

    const email = {
      sendEmailTo: [this.data.creator[0].email],
      sendEmailCc: this.organizationSetting.email,
      sendEmailSubject: this.data.tour.referenceNo + "-" + "The itinerary is currently being reviewed by " + this.data.tour.customer.first_name + " " + this.data.tour.customer.last_name
    };

    await this.itineraryService.emailSendToAdminsItinerary({
      sendInfo: data,
      emailInfo: email,
      organization: this.organizationSetting._id
    });
  }

  async loadItineraryByID(): Promise<any> {
    try {
      this.data = await this.itineraryService.getClientPreviewItineraryById({
        id: this.rId,
        pageType: this.pageType,
      });

      await this.settingService.findBrand(this.data.creator[0].creatorId);
      this.settingService.onBrandChange.subscribe((brand: any) => {
        this.organizationSetting = brand;
        this.setHeadingColor();
        this.tourOperatorTitle = this.getOPNameByLanguage(brand.tourOperatorHeading, this.data.tour.language);
      });

      await this.getLocalization(this.data.tour.language);
      await this.getCountries();

      this.image = this.data.viewSettings.mapType === SETTINGS.MAP_TYPES[0].value ?
        await this.mapDirectionsImage() :  await this.mapImage();

      // Update meta tags after data is loaded
      this.updateSocialMediaMetaTags();

      if (this.rWatched === "true" && this.data.isNotificationEnabled === true) {
        this.sendEmail().then();
      }

      this.countrySequence();
      this.citySequence();
    } catch (e: any) {
      this.messageService.error(e.error.message);
      this.router.navigate(["/unauthorized"]);
    }
  }

  countrySequence(): void {
    this.data.days.forEach((day: any) => {
      const country = day?.destination?.country;
      if (!this.countries.includes(country) && country !== undefined) {
        console.log(country);
        this.countries.push(country);
      }
    });
  }

  citySequence(): void {
    this.data.days.forEach((day: any) => {
      const country = day?.destination?.country;
      const city = day?.destination?.city;

      const countryIndex = this.citiesByCountry.findIndex((item: any) => item?.country === country);

      if (countryIndex === -1) {
        this.citiesByCountry.push({country, cities: [city]});
      } else {
        // If country already exists, add city only if it's not already present
        if (!this.citiesByCountry[countryIndex].cities.includes(city)) {
          this.citiesByCountry[countryIndex].cities.push(city);
        }
      }
    });
  }

  // getAccommodationPerDate(day: any): any[] {
  //   const accommodations = [];
  //   for (const accommodation of this.data.accommodation) {
  //     const date = moment(day).startOf("day");
  //     const checkIn = moment(accommodation.checkIn).startOf("day");
  //     let checkOut = moment(accommodation.checkOut).startOf("day");
  //
  //     // Adjust the checkOut date only if it's not the same as the date (current day)
  //     if (!checkOut.isSame(checkIn)) {
  //       checkOut = checkOut.subtract(1, "day");
  //     }
  //
  //     if (date.isSameOrAfter(checkIn) && date.isSameOrBefore(checkOut)) {
  //       accommodations.push(accommodation);
  //     }
  //   }
  //   return accommodations;
  // }

  displayTitle(titles: any, defaultLanguage: string): string {
    return titles
      .filter((item: any) => item.language === defaultLanguage)
      .map((item: any) => item.name);
  }

  isStringLengthLessThanLimit(str: string, limit: number): boolean {
    return str.length < limit;
  }

  viewContent(content: string, title: string): void {
    const isRichText = false;
    this.nzModalService
      .create({
        nzWidth: "500px",
        nzContent: ViewContentComponent,
        nzFooter: null,
        nzComponentParams: {
          content,
          title,
          isRichText
        },
      })
      .afterClose.subscribe(data => {
      if (data.status === "success"){
        this.ngOnInit();
      }
    });
  }

  viewContentInnerHtml(content: string, title: string): void {
    const isRichText = true;
    this.nzModalService
      .create({
        nzWidth: "900px",
        nzContent: ViewContentComponent,
        nzFooter: null,
        nzComponentParams: {
          content,
          title,
          isRichText
        },
      })
      .afterClose.subscribe(data => {
      if (data.status === "success"){
        this.ngOnInit();
      }
    });
  }

  addEditCustomerInformation(singleItinerary: any): void {
    this.nzModalService
      .create({
        nzWidth: "800px",
        nzContent: AddEditCustomerInformationComponent,
        nzFooter: null,
        nzComponentParams: {
          singleItinerary
        },
      })
      .afterClose.subscribe(data => {
      if (data.status === "success"){
        location.reload();
      }
    });
  }

  async mapImage(): Promise<any> {
    try {
      let geoJSON: any | undefined;

      if (this.data?.days[0]?.transport.length !== 0){
        const {locationFrom} = this.data?.days[0]?.transport[0];
        if (locationFrom){
          geoJSON = geoJSONManager(geoJSON, parseFloat(locationFrom?.latitude), parseFloat(locationFrom?.longitude));
        }
      }

      this.data.days.forEach((day: any) => {
        if (day?.destination) {
          const {location} = day?.destination;
          geoJSON = geoJSONManager(geoJSON, parseFloat(location?.latitude), parseFloat(location?.longitude));
        }
      });

      const lastDay = this.data.days.length - 1;
      if (this.data?.days[lastDay]?.transport.length !== 0){
        const lastTransport = this.data?.days[lastDay]?.transport.length - 1;
        const {locationTo} = this.data?.days[lastDay]?.transport[lastTransport];
        if (locationTo){
          geoJSON = geoJSONManager(geoJSON, parseFloat(locationTo?.latitude), parseFloat(locationTo?.longitude));
        }
      }

      return await this.mapBoxService.getMapImage(geoJSON);
    } catch (e) {
    }

  }

  async mapDirectionsImage(): Promise<any> {
    try {
      // Collect all waypoints from the itinerary
      const waypoints: Array<{lat: number, lng: number}> = [];

      // Add starting point from first transport
      if (this.data?.days[0]?.transport.length !== 0) {
        const {locationFrom} = this.data?.days[0]?.transport[0];
        if (locationFrom) {
          waypoints.push({
            lat: parseFloat(locationFrom.latitude),
            lng: parseFloat(locationFrom.longitude)
          });
        }
      }

      let prevId: string | undefined;
      // Add destination points
      for (const day of this.data?.days ?? []) {
        const dest = day?.destination;
        if (!dest?.location) {
          continue;
        }

        const curId = dest._id as string | undefined;
        if (curId && curId === prevId) {
          continue;
        } // same as previous -> skip

        const {latitude, longitude} = dest.location;
        const lat = typeof latitude === "number" ? latitude : parseFloat(latitude);
        const lng = typeof longitude === "number" ? longitude : parseFloat(longitude);
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          waypoints.push({lat, lng});
        }
        prevId = curId;
      }

      // Add ending point from last transport
      const lastDay = this.data.days.length - 1;
      if (this.data?.days[lastDay]?.transport.length !== 0) {
        const lastTransport = this.data?.days[lastDay]?.transport.length - 1;
        const {locationTo} = this.data?.days[lastDay]?.transport[lastTransport];
        if (locationTo) {
          waypoints.push({
            lat: parseFloat(locationTo.latitude),
            lng: parseFloat(locationTo.longitude)
          });
        }
      }
      return await this.mapBoxService.getStaticMapWithDirections(false, waypoints);
    } catch (e) {
      console.error('Error generating map image with directions:', e);
      return null;
    }
  }

  customizeDate(value: string, setting: string): string {
    return moment(value).format(setting);
  }

  async getCountries(): Promise<void> {
    this.countriesJson = await this.countryService.getCountries();
  }

  findCountryFlagImage(countryCode: string): string {
    const selected_country = this.countriesJson.find(
      (c: any) => c.code === countryCode
    );
    return selected_country?.image;
  }

  async generatePDF(): Promise<void> {
    this.loading = true;
    let mapUrl: any = null;
    mapUrl = this.data.viewSettings.mapType === SETTINGS.MAP_TYPES[0].value ? await this.mapDirectionsImage() : this.mapImage();
    const countryImageURL = this.data?.tour?.customer?.country?.code ?
      this.findCountryFlagImage(this.data?.tour.customer.country.code) : "";
    const payload = {
      day: this.data.days.length,
      night: this.data.days.length - 1,
      clientTimezoneOffset: new Date().getTimezoneOffset(),
      ...this.data,
      ...this.organizationSetting,
      citiesByCountry: this.citiesByCountry,
      countries: this.countries,
      mapURL: mapUrl,
      itinerary: this.data?.itinerary,
      companyName: this.data?.b2b?.customer?.companyName || "",
      logo: this.data?.b2b?.customer?.logo,
      costing: this.data?.b2b?.costing,
      companyDetails: {summary: this.data?.b2b?.customer?.summary || "" , websiteLink: this.data?.b2b?.customer?.websiteLink || ""},
      countryImageURL,
      pdfViewOptions: SETTINGS.PDF_VIEW_OPTIONS
    };
    this.reportService.generateItineraryReport(payload).then((res) => {
      const fileName = `${this.data.tour.referenceNo}-${this.data?.b2b?.customer?.companyName ? this.data?.b2b?.customer?.companyName : "No Name"} `;
      this.reportService.downloadReport(res, fileName);
      this.loading = false;
    });
  }

  timeUntil24HoursExpires(dateTime: string): string {
    const now = moment();
    const givenTime = moment(dateTime);
    const elapsedHours = now.diff(givenTime, "hours", true);
    const remainingTime = 24 - elapsedHours;
    const remainingHours = Math.floor(remainingTime); // Whole hours
    const remainingMinutes = Math.round((remainingTime - remainingHours) * 60); // Remaining minutes

    return `${remainingHours}h ${remainingMinutes}m`;
  }
  determineToShow(): boolean {
    return this.data.b2b.customer.logo !== "" || this.data.b2b.customer.companyName !== "" ||
      this.data.b2b.customer.websiteLink !== "" || this.data.b2b.customer.summary !== "";
  }

  async getLocalization(lang: string): Promise<any> {
    this.localizationContent = await this.localizationService.getLocalizationContent(lang);
  }

  async updateViewCount(): Promise<void> {
    await this.itineraryService.updateB2BItinerary({_id: this.rId, viewCount: this.data?.viewCount + 1 });
  }

  navigateToDay(i: number): void {
    const el = document.getElementById(`day-${i}`);
    if (el) {
      this.selectDay(i);
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  selectDay(i: number): void {
    this.selectedDayIndex = i;
  }

  navigateUrl(url: string): void {
    console.log(url);
    const newWindow: any = window.open(url, '_blank', 'noopener,noreferrer');
    newWindow.focus();
  }

  private updateSocialMediaMetaTags(): void {
    // Ensure we have proper absolute URLs for images
    let imageUrl = this.data?.featured?.image;
    if (imageUrl && !imageUrl.startsWith('http')) {
      // Convert relative URLs to absolute URLs
      imageUrl = `${window.location.origin}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
    }

    // Use a default image if no image is provided
    if (!imageUrl) {
      imageUrl = `${window.location.origin}/assets/img/placeholder-image.png`;
    }

    this.metaService.updateMetaTags({
      title: this.data?.title || "Travsta Itinerary",
      description: this.data?.featured?.description  || "Travsta Itinerary",
      imageUrl,
      url: window.location.href
    });
  }


  setHeadingColor(): void {
    if (this.organizationSetting?.uiOptions[1]?.brandColor_heading) {
      this.headingColor = this.organizationSetting?.uiOptions[1]?.brandColor_heading;
    }
    // Set CSS custom property for dynamic styling
    document.documentElement.style.setProperty('--heading-color', this.headingColor);
  }

  getCellDisplay(i: number, cell: any): string {
    return formatDynamicPricingCell(
      this.data?.costing?.dynamicPricing?.headers,
      i,
      cell,
      this.data?.tour?.currency
    );
  }
}
